import React, { useState, useEffect, useRef, createRef, memo } from "react";
import { Constants, useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import { BottomBar } from "./components/BottomBar";
import { SidebarConatiner } from "../components/sidebar/SidebarContainer";
import MemorizedParticipantView from "./components/ParticipantView";
import { PresenterView } from "../components/PresenterView";
import { nameTructed, trimSnackBarText } from "../utils/helper";
import WaitingToJoinScreen from "../components/screens/WaitingToJoinScreen";
import ConfirmBox from "../components/ConfirmBox";
import useIsMobile from "../hooks/useIsMobile";
import useIsTab from "../hooks/useIsTab";
import { useMediaQuery } from "react-responsive";
import { toast } from "react-toastify";
import { useMeetingAppContext } from "../MeetingAppContextDef";
import { useHistory } from "react-router-dom";

export function MeetingContainer({
  onMeetingLeave,
  setIsMeetingLeft,
  isCapture="",
  imageCallback=()=>{}
}) {
  const {
    setSelectedMic,
    setSelectedWebcam,
    setSelectedSpeaker,
  } = useMeetingAppContext();

  const [participantsData, setParticipantsData] = useState([]);

  const { localParticipant } = useMeeting();

  const history = useHistory();

  console.log("participantsData",participantsData)
    const { webcamStream,  captureImage } = useParticipant(participantsData[0]?.id||"");

    async function imageCapture() {
      if ( webcamStream) {
        const base64 = await captureImage({ height: 400, width: 400 }); // captureImage will return base64 string
        console.log("base64", base64);
        return base64;
      } else {
        console.error("Camera must be on to capture an image");
      }
    }
    useEffect(async()=>{
      console.log("isCapture",isCapture);
      let imageData = await imageCapture()
      imageCallback(imageData);
    },[isCapture])

    // const { remove:leaveParticipant } = useParticipant(participantsData[participantsData.length-1]);

    useEffect(() => {
    if(participantsData.length>= 3){
      // setLocalParticipantAllowedJoin(false);
      leave();
      toast.warning("Can not join this call, Reacjed max limit of 2 participants",{
              position: toast.POSITION.BOTTOM_CENTER,
            }); 
      if (window.location.pathname.includes("/azure-video")){
        history.push("/rapid?azureVideoCall=true");
      }else{
        setTimeout(()=>{
          history.push("/customer-connect?leave=true");
        },500);
      }
    }
  
    return null;
  }, [participantsData]);

  const ParticipantMicStream = memo(({ participantId }) => {
    // Individual hook for each participant
    const { micStream } = useParticipant(participantId);

    
  
    useEffect(() => {
      if (micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);
  
        const audioElement = new Audio();
        audioElement.srcObject = mediaStream;
        audioElement.play();

      }
    }, [micStream, participantId]); 
    return null;
  }, [participantsData]);

  const { useRaisedHandParticipants } = useMeetingAppContext();
  const bottomBarHeight = 60;

  const [containerHeight, setContainerHeight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [localParticipantAllowedJoin, setLocalParticipantAllowedJoin] = useState(null);
  const [meetingErrorVisible, setMeetingErrorVisible] = useState(false);
  const [meetingError, setMeetingError] = useState(false);

  const mMeetingRef = useRef();
  const containerRef = createRef();
  const containerHeightRef = useRef();
  const containerWidthRef = useRef();

  useEffect(() => {
    containerHeightRef.current = containerHeight;
    containerWidthRef.current = containerWidth;
  }, [containerHeight, containerWidth]);




  const isMobile = useIsMobile();
  const isTab = useIsTab();
  const isLGDesktop = useMediaQuery({ minWidth: 1024, maxWidth: 1439 });
  const isXLDesktop = useMediaQuery({ minWidth: 1440 });

  const sideBarContainerWidth = isXLDesktop
    ? 400
    : isLGDesktop
      ? 360
      : isTab
        ? 320
        : isMobile
          ? 280
          : 240;

  useEffect(() => {
    containerRef.current?.offsetHeight &&
      setContainerHeight(containerRef.current.offsetHeight);
    containerRef.current?.offsetWidth &&
      setContainerWidth(containerRef.current.offsetWidth);

    window.addEventListener("resize", ({ target }) => {
      containerRef.current?.offsetHeight &&
        setContainerHeight(containerRef.current.offsetHeight);
      containerRef.current?.offsetWidth &&
        setContainerWidth(containerRef.current.offsetWidth);
    });
  }, [containerRef]);


  const _handleMeetingLeft = () => {
    setIsMeetingLeft(true);
  };

    const { leave ,end,join} = useMeeting();
    

    useEffect(() => {
      setTimeout(()=>{
        join({ 
          micEnabled: true,
          webcamEnabled: true,
          config: {
            resolution: "h180p_w320p",
            maxResolution: "h480p_w854p",
          }}
        );
      },3000)
    },[])

    useEffect(()=>{
      return(()=>{
        end();
      })
    },[])
  

  // const _handleOnRecordingStateChanged = ({ status }) => {
  //   if (
  //     status === Constants.recordingEvents.RECORDING_STARTED ||
  //     status === Constants.recordingEvents.RECORDING_STOPPED
  //   ) {
  //     // toast(
  //     //   `${status === Constants.recordingEvents.RECORDING_STARTED
  //     //     ? "Meeting recording is started"
  //     //     : "Meeting recording is stopped."
  //     //   }`,
  //     //   {
  //     //     position: "bottom-left",
  //     //     autoClose: 4000,
  //     //     hideProgressBar: true,
  //     //     closeButton: false,
  //     //     pauseOnHover: true,
  //     //     draggable: true,
  //     //     progress: undefined,
  //     //     theme: "light",
  //     //   }
  //     // );
  //   }
  // };

  function onParticipantJoined(participant) {
    // Change quality to low, med or high based on resolution
    const isMobile = /Android|iPhone/i.test(navigator.userAgent);
    participant && participant.setQuality(isMobile?"low":"med");

  }


  function onEntryResponded(participantId, name) {
    if (mMeetingRef.current?.localParticipant?.id === participantId) {
      if (name === "allowed") {
        setLocalParticipantAllowedJoin(true);
        console.log("participant count",participantsData)
      } else {
        setLocalParticipantAllowedJoin(false);
        setTimeout(() => {
          _handleMeetingLeft();
        }, 3000);
      }
    }
  }

  function onMeetingJoined() {
    console.log("onMeetingJoined");
  }

  function onMeetingLeft() {
    setSelectedMic({ id: null, label: null })
    setSelectedWebcam({ id: null, label: null })
    setSelectedSpeaker({ id: null, label: null })
    onMeetingLeave();
  }

  const _handleOnError = (data) => {
    const { code, message } = data;
    console.log("meetingErr", code, message)

    const joiningErrCodes = [
      4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010,
    ];

    const isJoiningError = joiningErrCodes.findIndex((c) => c === code) !== -1;
    const isCriticalError = `${code}`.startsWith("500");

    new Audio(
      isCriticalError
        ? `https://static.videosdk.live/prebuilt/notification_critical_err.mp3`
        : `https://static.videosdk.live/prebuilt/notification_err.mp3`
    ).play();

    setMeetingErrorVisible(true);
    setMeetingError({
      code,
      message: isJoiningError ? "Unable to join meeting!" : message,
    });
  };

  const mMeeting = useMeeting({
    onParticipantJoined,
    onEntryResponded,
    onMeetingJoined,
    onMeetingLeft,
    onError: _handleOnError,
    config: {
      
    }
    // onRecordingStateChanged: _handleOnRecordingStateChanged,
  });

  const isPresenting = mMeeting.presenterId ? true : false;

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      const participantIds = Array.from(mMeeting.participants.keys());
      console.log("Debounced participantIds", participantIds);

      setParticipantsData(participantIds);
      console.log("Setting participants");
    }, 500); 


    return () => clearTimeout(debounceTimeout);
  }, [mMeeting.participants]);


  useEffect(() => {
    mMeetingRef.current = mMeeting;
  }, [mMeeting]);


  // usePubSub("RAISE_HAND", {
  //   onMessageReceived: (data) => {
  //     const localParticipantId = mMeeting?.localParticipant?.id;

  //     const { senderId, senderName } = data;

  //     const isLocal = senderId === localParticipantId;

  //     new Audio(
  //       `https://static.videosdk.live/prebuilt/notification.mp3`
  //     ).play();

  //     // toast(`${isLocal ? "You" : nameTructed(senderName, 15)} raised hand 🖐🏼`, {
  //     //   position: "bottom-left",
  //     //   autoClose: 4000,
  //     //   hideProgressBar: true,
  //     //   closeButton: false,
  //     //   pauseOnHover: true,
  //     //   draggable: true,
  //     //   progress: undefined,
  //     //   theme: "light",
  //     // });

  //     participantRaisedHand(senderId);
  //   },
  // });

  // usePubSub("CHAT", {
  //   onMessageReceived: (data) => {
  //     const localParticipantId = mMeeting?.localParticipant?.id;

  //     const { senderId, senderName, message } = data;

  //     const isLocal = senderId === localParticipantId;

  //     if (!isLocal) {
  //       new Audio(
  //         `https://static.videosdk.live/prebuilt/notification.mp3`
  //       ).play();

  //       // toast(
  //       //   `${trimSnackBarText(
  //       //     `${nameTructed(senderName, 15)} says: ${message}`
  //       //   )}`,
  //       //   {
  //       //     position: "bottom-left",
  //       //     autoClose: 4000,
  //       //     hideProgressBar: true,
  //       //     closeButton: false,
  //       //     pauseOnHover: true,
  //       //     draggable: true,
  //       //     progress: undefined,
  //       //     theme: "light",
  //       //   }
  //       // );
  //     }
  //   },
  // });

  return (
    <div className="fixed inset-0">
      <div ref={containerRef} className="h-full flex flex-col bg-gray-800">
        {typeof localParticipantAllowedJoin === "boolean" ? (
          localParticipantAllowedJoin ? (
            <>
              <div className={` flex flex-1 flex-row bg-gray-800 `}>
                <div className={`flex flex-1 `}>
                  {isPresenting ? (
                    <PresenterView height={containerHeight - bottomBarHeight} />
                  ) : null}
                  {isPresenting && isMobile ? (
                    participantsData.map((participantId) => (
                      <ParticipantMicStream key={participantId} participantId={participantId} />
                    ))
                  ) : (
                    <MemorizedParticipantView isPresenting={isPresenting} />
                  )}
                </div>

                <SidebarConatiner
                  height={containerHeight - bottomBarHeight}
                  sideBarContainerWidth={sideBarContainerWidth}
                />
              </div>
              <BottomBar
                bottomBarHeight={bottomBarHeight}
                setIsMeetingLeft={setIsMeetingLeft}
              />
            </>
          ) : (
            <></>
          )
        ) : (
          !mMeeting.isMeetingJoined && <WaitingToJoinScreen />
        )}
        <ConfirmBox
          open={meetingErrorVisible}
          successText="OKAY"
          onSuccess={() => {
            setMeetingErrorVisible(false);
          }}
          title={`Error Code: ${meetingError.code}`}
          subTitle={meetingError.message}
        />
      </div>
    </div>
  );
}
